import { DatePipe } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { ActivityStoreFacade } from '../../../common/facade/ActivityStoreFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { CatalogDetInfo } from '../../../common/model/dictionary/CatalogDetInfo';
import { StoreReportChecklistDto } from '../../../common/model/dto/StoreReportChecklistDto';
import { Organization } from '../../../common/model/Organization';
import { ExcelUtility } from '../../../common/util/ExcelUtility';


@Component({
  selector: 'app-store-report-checklist',
  templateUrl: './store-report-checklist.component.html',
  styleUrls: ['./store-report-checklist.component.css']
})
export class StoreReportChecklistComponent implements OnInit {
  public res = res;
  titleStoresReport = res.StoresReportChecklist;
  lblDownload = res.Download;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;
  lblSearch = res.Search;
  lblStore = res.Store;
  lblExecutive = res.Executive;
  lblBrand = res.Brand;
  lblStoreType = res.StoreType;
  lblScoreExt = res.ScoreExt;
  lblScoreInt = res.ScoreInt;
  lblScoreVar = res.ScoreVar;
  lblTotal = res.Total;
  lblDate = res.ActivityDate;
  lblReception = res.Reception;
  lblMerchandiseEntry = res.MerchandiseEntry;
  lblCorrectiveActions = res.CorrectiveActions;
  public catDetMerchandiseEntry = CatalogDetInfo.catDetToUseShipmentEntry;
  public catDetReception = CatalogDetInfo.catDetToUseShipmentReception;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: '',
  };

  loading = false;
  messageLoader = '';
  message = '';
  public backToVisible = false;
  public lstStoreReportCheckList: StoreReportChecklistDto[] = [];
  public storeReportCheckList: StoreReportChecklistDto;
  private _filteredData = [];
  public txtSearch = '';
  public txtMinDate = new Date(
    this.getNowUTC().getFullYear() - 4,
    this.getNowUTC().getMonth(),
    1,
    this.getNowUTC().getHours(),
    this.getNowUTC().getMinutes(),
    this.getNowUTC().getSeconds(),
    this.getNowUTC().getMilliseconds()
  );
  public txtMaxDate = this.getNowUTC();
  public txtStartDate = new Date();
  public txtEndDate = new Date();

  // alert
  alerts: any[] = [];

  public TenantId = 0;
  organizationId: string;

  lstOrganization: Organization[] = [];
  availableOrganizations: Organization[] = [];
  selectedOrganizations: Organization[] = [];
  public organizationSelected: any[] = [];
  strOrganizationSelected: string;
  botonEnable: boolean;

  constructor(
    @Inject(SESSION_STORAGE) private storage: WebStorageService,
    private _facade: ActivityStoreFacade,
    private _router: Router,
    private _route: ActivatedRoute,
    private _excel: ExcelUtility,
    public strings: Strings,
    private localeService: BsLocaleService
  ) {
    this.storage.set('moduleUrl', this._router.url);
  }

  ngOnInit() {
    this.messageLoader = 'Cargando';
    this.messagesTable.emptyMessage = this.strings.GetText(
      res.ThereIsNoInformation
    );
    this.messagesTable.totalMessage = 'Total';

    this.TenantId = this.strings.getTenant();
    this.localeService.use(this.strings.getLanguage());

    this.availableOrganizations = this.strings.getAvailableOrganizations();
    this.lstOrganization = this.availableOrganizations.filter(
      (Orga) => Orga.tenantId == this.TenantId
    );
    this._route.queryParams.subscribe((params) => {
      if (params['orgId'] !== undefined) {
        this.organizationId = params['orgId'];
        this.strOrganizationSelected = this.organizationId;
        this.organizationSelected = this.lstOrganization.filter((org) =>
          this.organizationId.includes(org.organizationId)
        );
        this.selectedOrganizations = this.lstOrganization;
        this.botonEnable = true;
      }

      if (
        params['startDate'] !== undefined &&
        params['endDate'] !== undefined
      ) {
        this.txtStartDate = new Date(params['startDate']);
        this.txtEndDate = new Date(params['endDate']);
        this.getReportBy();
      }
    });
  }

  onChangeStartDate(value) {
    value = this.subtractTimeFromDate(value, 6);
    this.txtStartDate = value;

    if (this.txtStartDate > this.txtEndDate) {
      this.addAlert(
        '<strong>!Error¡</strong> ' +
        this.strings.GetText(res.AlertTheStartDateCannotBeHigher),
        'danger'
      );
    }
  }

  onChangeEndDate(value) {
    value = this.subtractTimeFromDate(value, 6);
    this.txtEndDate = value;
  }

  // añadir alert
  addAlert(message: String, type: String): void {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message,
    });
  }
  /**
   * Método para cerarr las notificaciones.
   * @param dismissedAlert
   */
  // cerrar alert
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    this.txtSearch = event.target.value.toLowerCase();
    // get the amount of columns in the table
    this.filterData(this.txtSearch);
  }

  /**
   * Método para descargar el reporte de las tiendas
   */
  downloadLayout() {
    if (this.lstStoreReportCheckList.length > 0) {
      const data: any = [];
      this.lstStoreReportCheckList.forEach((row) => {
        const info = {
          [this.strings.GetText(res.Executive)]: row.executive,
          [this.strings.GetText(res.Brand)]: row.tradeMark,
          [this.strings.GetText(res.StoreName)]:
            row.storeName,
          [this.strings.GetText(res.StoreType)]:
            row.storeType,
          [this.strings.GetText(res.Date)]:
            row.lastDateUpdate,
          [this.strings.GetText(res.ScoreExt)]:
            row.scoreOutside,
          [this.strings.GetText(res.ScoreInt)]: row.scoreInside,
          [this.strings.GetText(res.ScoreVar)]:
            row.scoreVarious,
          [this.strings.GetText(res.Total)]: row.total,

        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, 'data');
    } else {
      this.addAlert(this.strings.GetText(res.AlertNoInfoToDownload), 'danger');
    }
  }

  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + now.getTimezoneOffset() * 60000);
  }

 

  private filterData(val) {
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.lstStoreReportCheckList = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (
          item[keys[i]] != null &&
          (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)
        ) {
          return true;
        }
      }
    });
  }

  getReportBy() {
    this.loading = true;
    var orgdata = "";
    if (this.txtStartDate > this.txtEndDate) {
      this.addAlert(
        '<strong>' +
        this.strings.GetText(res.AlertTheStartDateCannotBeHigher) +
        '</strong>',
        'danger'
      );
      this.loading = false;
    } else {
      this._facade
        .GetStoresReportCheckList(this.txtStartDate, this.txtEndDate)
        .subscribe(
          (result) => {
            if (result.completed) {
              this.lstStoreReportCheckList = result.data.filter((org) =>
                this.strOrganizationSelected.includes(org.organizationId),
              );
              this._filteredData = this.lstStoreReportCheckList;
            } else {
              this.addAlert(
                '<strong>' + result.message + '</strong>',
                'danger'
              );
            }
            this.loading = false;
          },
          (error) => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
          }
        );
    }
  }

  onChangeOrganization(selectedOrganizations: any[]) {
    this.selectedOrganizations = selectedOrganizations;
    this.strOrganizationSelected = this.selectedOrganizations
      .map((e) => e.organizationId)
      .join(',');
    if (selectedOrganizations.length > 0) {
      this.botonEnable = true;
    } else {
      this.botonEnable = false;
      this.lstStoreReportCheckList = [];
    }
  }

  search() {
    this.getReportBy();
  }

  subtractTimeFromDate(objDate, intHours) {
    var numberOfMlSeconds = objDate.getTime();
    var addMlSeconds = intHours * 60 * 60000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    return newDateObj;
  }
}
